import BaseLayout from '../../layout/BaseLayout';
import {GenericError} from './GenericError';

export function GenericErrorPage() {
  return (
    <BaseLayout transparentBackground>
      <GenericError />
    </BaseLayout>
  );
}
